import { Component } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { StorageService } from './../../providers/storage.service';
import { ChangeService } from './../../services/change.service';
import { LoaddingService } from './../../providers/loadding.service';
import { PageDefault } from '../../pages/PageDefault';
import { UserModel } from './../../models/user.model';
import { AccountSearch } from './accountsearch';


/*
    帐变记录
*/
@Component({
    selector: "accountchange",
    templateUrl: "accountchange.html",
    providers: [ChangeService]
})
export class AccountChange {
    constructor(
        public storage: StorageService,
        public ChangeService: ChangeService,
        private loadding: LoaddingService,
        private modalCtrl: ModalController

    ) { }
    records = [];
    excludeTracks = [];
    isHave: boolean = false;
    username = this.storage.read<UserModel>("User").UserName;
    site = new AccountSearchInput();
    paras = new TeamAccountInput();
    hasmore: boolean = false;
    teamFlag:boolean=false;

    //查询点击事件
    record(obj:AccountSearchInput) {
        return this.ChangeService.getChangeRecord(obj).then(s => {
            if (obj.pageIndex == 1) {
                this.records = [];
                this.records = s.List;
                if (s.List.length < s.PageCount) {
                    this.hasmore = true;
                } else {
                    this.hasmore = false;
                }
            } else {
                this.records = this.records.concat(s.List);
                if (this.records.length < s.PageCount) {
                    this.hasmore = true;
                }
                else {
                    obj.pageIndex = 1;
                    this.hasmore = false;
                }
            }
            if (this.records.length < 1) {
                this.isHave = false;
            } else {
                this.isHave = true;
            }
        });
    }
    //团队帐变记录
    teamaccountchange(obj:TeamAccountInput){
        return this.ChangeService.QueryTeamChange(obj.subUserName,obj.startDate,obj.endDate,obj.typeCode,obj.pageIndex,obj.pageSize).then(s => {
            if (obj.pageIndex == 1) {
                this.records = [];
                this.records = s.List;
                if (s.List.length < s.PageCount) {
                    this.hasmore = true;
                } else {
                    this.hasmore = false;
                }
            } else {
                this.records = this.records.concat(s.List);
                if (this.records.length < s.PageCount) {
                    this.hasmore = true;
                }
                else {
                    obj.pageIndex = 1;
                    this.hasmore = false;
                }
            }
            if (this.records.length < 1) {
                this.isHave = false;
            } else {
                this.isHave = true;
            }
        });
    }

    //查询条件
    presentFilter() {
        let modal = this.modalCtrl.create(AccountSearch, this.excludeTracks);
        modal.present();
        modal.onWillDismiss((data: any[]) => {
            if (data) {
                this.excludeTracks = data;                       
                if(this.excludeTracks["type"]=="1"){
                    this.teamFlag=true;
                    this.paras.startDate = this.excludeTracks["startDate"];
                    this.paras.endDate = this.excludeTracks["endDate"];
                    this.paras.subUserName = this.excludeTracks["subUserName"];
                    this.teamaccountchange(this.paras);
                    
                }else{
                    this.teamFlag=false;
                    this.site.userName = this.username;
                    this.site.startDate = this.excludeTracks["startDate"];
                    this.site.endDate = this.excludeTracks["endDate"];
                    this.record(this.site);
                }
                
            }
        });
    }

    //页面加载
    ionViewDidLoad() {
        this.site.userName = this.username;
        let load = this.loadding.showLoding();
        this.record(this.site).then(() => {
            this.loadding.closeLoading(load);
        });
    }

    //下拉重新加载
    //TQQ 2017-01-03
    doRefresh(refresher) {
        this.site.pageIndex = 1;
        this.paras.pageIndex = 1;
        if(!this.teamFlag){
            this.record(this.site).then(s=>{
                refresher.complete();
            });
        }else{
            this.teamaccountchange(this.paras).then(s=>{
                refresher.complete();
            });
        }
    }

    //上拉获取下一页信息
    //TQQ 2017-01-03
    doInfinite(infiniteScroll) {
        this.site.pageIndex++;
        this.paras.pageIndex++;
        if(!this.teamFlag){
            this.record(this.site).then(s=>{
                infiniteScroll.complete();
            });
        }else{
            this.teamaccountchange(this.paras).then(s=>{
                infiniteScroll.complete();
            });
        }
    }
}

export class AccountSearchInput {
    startDate: string = PageDefault.endNowDate();
    endDate: string = PageDefault.endDate();
    typeCode: string = "_ALL";
    pageSize: number = PageDefault.PageSize();
    pageIndex: number = 1;
    lotteryName: string = "_ALL";
    issueNo: string = "";
    bettingId: number = 0;
    userName: string
}
export class TeamAccountInput {
    startDate: string = PageDefault.endNowDate();
    endDate: string = PageDefault.endDate();
    typeCode: string = "_ALL";
    pageSize: number = PageDefault.PageSize();
    pageIndex: number = 1;
    subUserName: string = "";
}


// WEBPACK FOOTER //
// ./src/pages/accountchange/accountchange.ts